import React, {useCallback, useRef} from 'react'

const THRESHOLD = 100

/**
 * Renders a scrollable list and calls onFetchMore when the user scrolls near the bottom.
 * @param {object} props
 * @param {React.ReactNode} props.children - List content to render
 * @param {() => void} props.onFetchMore - Called when scroll reaches bottom
 * @param {boolean} props.hasMore - Whether more data is available
 * @param {React.ReactNode} [props.loader] - Optional loader shown at bottom when loading more
 * @param {number} [props.height] - Height of scroll container (px)
 * @param {string} [props.className] - Additional CSS class for the scroll container
 */
function InfiniteScroll({children, onFetchMore, hasMore, loader = null, height, className = ''}) {
    const containerRef = useRef(null)

    const handleScroll = useCallback(() => {
        const el = containerRef.current
        if (!el || !hasMore || typeof onFetchMore !== 'function') return
        const {scrollTop, scrollHeight, clientHeight} = el
        if (scrollHeight - scrollTop - clientHeight < THRESHOLD) {
            onFetchMore()
        }
    }, [hasMore, onFetchMore])

    return (
        <div
            ref={containerRef}
            className={className}
            style={height != null ? {height, overflow: 'auto'} : undefined}
            onScroll={handleScroll}
        >
            {children}
            {loader}
        </div>
    )
}

export default InfiniteScroll
